import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import "./Css/PaymentEdit.css";

const BookEdit = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const exam = state?.exam;

  const [formData, setFormData] = useState({
    name: exam?.name || "",
    sudname: exam?.sudname || "",
    date: exam?.date || "",
    amount: exam?.amount || "",
    cumission: exam?.cumission || "",
    paymentStatus: exam?.paymentStatus || false,
  });

  if (!exam) {
    return <p>डेटा उपलब्ध नाही</p>;
  }

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
navigate('/dashboard/bookmanagment'); 
  };

  return (
    <div className="transaction-container ">
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          पुस्तक व्यवस्थापन  &gt;&gt; <span>पुस्तक संपादन</span>
        </h3>

        <div className="edit-btnn">
          <button className="btn outlinee" onClick={() => navigate(-1)}>
            रद्द करा
          </button>
          <button className="primary-btn" onClick={handleSubmit}>
            जतन करा
          </button>
        </div>
      </div>

      <div className="form-card">
        <h3 className="form-title">पुस्तक संपादन करा </h3>

        <form className="form-grid" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>पुस्तकाचं नाव</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>विद्यार्थ्याचे नाव</label>
            <input
              type="text"
              name="sudname"
              value={formData.sudname}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>पेमेंट तारीख</label>
            <input
              type="text"
              name="date"
              value={formData.date}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>किंमत ₹</label>
            <input
              type="text"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>कमिशन %</label>
            <input
              type="text"
              name="cumission"
              value={formData.cumission}
              onChange={handleChange}
            />
          </div>
<div className="form-group">
  <label>पेमेंट स्थिती</label>
  <input
    type="text"
    value={formData.paymentStatus ? "जमा" : "बाकी"}
    readOnly
  />
</div>

         
        </form>
      </div>
    </div>
  );
};

export default BookEdit;
